import type { AccessGateState, PostLoginPath } from "@crewledger/shared/beta-access";
import { POST_LOGIN_PATHS } from "@crewledger/shared/beta-access";

const GATE_ALLOWED_PATHS: Record<PostLoginPath, readonly string[]> = {
  [POST_LOGIN_PATHS.REQUEST_ACCESS]: [
    POST_LOGIN_PATHS.REQUEST_ACCESS,
    `${POST_LOGIN_PATHS.REQUEST_ACCESS}/success`,
    "/login",
  ],
  [POST_LOGIN_PATHS.NOT_INVITED]: [
    POST_LOGIN_PATHS.NOT_INVITED,
    POST_LOGIN_PATHS.REQUEST_ACCESS,
    `${POST_LOGIN_PATHS.REQUEST_ACCESS}/success`,
    "/login",
  ],
  [POST_LOGIN_PATHS.ACCESS_DENIED]: [POST_LOGIN_PATHS.ACCESS_DENIED, "/login"],
  [POST_LOGIN_PATHS.BETA_ONBOARDING]: [
    POST_LOGIN_PATHS.BETA_ONBOARDING,
    "/get-started",
    "/login",
  ],
  [POST_LOGIN_PATHS.ADMIN]: [
    POST_LOGIN_PATHS.ADMIN,
    "/admin/beta-access",
    "/admin/platform/features",
    "/login",
  ],
  [POST_LOGIN_PATHS.DASHBOARD]: ["/"],
};

export function isPathAllowedForRedirect(
  currentPath: string,
  redirectTo: PostLoginPath,
  provisioned: boolean,
): boolean {
  if (provisioned && redirectTo === POST_LOGIN_PATHS.DASHBOARD) {
    return true;
  }

  const allowed = GATE_ALLOWED_PATHS[redirectTo] ?? [redirectTo];
  return allowed.some((path) => currentPath === path || currentPath.startsWith(`${path}/`));
}

export type { AccessGateState, PostLoginPath };
